import _ from 'lodash';

export default function draftToPayload(draft) {
    return draft;
}
